export default __webpack_public_path__ + "static/media/children.dd9319b4.jpg";